var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 27.067C41.117 21.317 36.067 17 30 17c-4.817 0-9 2.733-11.083 6.733A9.99 9.99 0 0010 33.667c0 5.516 4.483 10 10 10h21.667c4.6 0 8.333-3.734 8.333-8.334 0-4.4-3.417-7.966-7.75-8.266zM33.333 32v6.667h-6.666V32h-5L30 23.667 38.333 32h-5z",
    fill: "#E3B05F"
  })));
}

export default SvgListing;